import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#F3F5F1] border-t border-[#E5E8E3] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <Link to="/" className="font-serif-display text-3xl text-[#1A362D]" data-testid="footer-brand">
              activehuman<span className="text-[#C29B62]">.</span>
            </Link>
            <p className="mt-4 text-sm text-[#4A5D56] font-light max-w-sm leading-relaxed">
              A modern Indian nutraceutical brand focused on evidence-based nutrition and the foundations of everyday
              health.
            </p>
            <div className="mt-6 flex items-center gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="w-9 h-9 flex items-center justify-center border border-[#1A362D]/20 text-[#1A362D] hover:bg-[#1A362D] hover:text-[#FDFBF7] transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4" strokeWidth={1.5} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-[#1A362D] font-semibold mb-5">Contact</div>
            <ul className="space-y-3 text-sm text-[#4A5D56] font-light">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-[#C29B62]" strokeWidth={1.5} />
                <a href="mailto:hello@theactivehuman.com" data-testid="footer-email" className="activehuman-link-underline">
                  hello@theactivehuman.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#C29B62]" strokeWidth={1.5} />
                <span data-testid="footer-address">India</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.25em] text-[#1A362D] font-semibold mb-5">Legal</div>
            <ul className="space-y-3 text-sm text-[#4A5D56] font-light">
              <li>
                <Link to="/privacy" data-testid="footer-privacy-link" className="activehuman-link-underline">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-terms-link" className="activehuman-link-underline">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#1A362D]/10">
          <p
            data-testid="footer-disclaimer"
            className="text-xs md:text-sm text-[#4A5D56] font-light leading-relaxed max-w-3xl"
          >
            <span className="uppercase tracking-[0.2em] text-[#1A362D] font-semibold">Disclaimer</span> — This product
            is a nutritional supplement and is not intended to diagnose, treat, cure or prevent any disease. Read the
            label carefully before use. Not for medicinal use. Use under medical supervision if you have a medical
            condition, are pregnant or lactating. Store in a cool, dry place away from direct sunlight.
          </p>

          <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-[#4A5D56]/80">
            <span data-testid="footer-copyright">© {new Date().getFullYear()} Activehuman. All rights reserved.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
